import moment from "moment"
import { POST_PLAN } from "@/common/constants/postPlans"

const DATE_TIME_FORMAT = "YYYY-MM-DD HH:mm:ss"
const SECONDS_PER_HOUR = 3600

const isBlank = (value) => value === null || value === undefined || value === ""

const toUnix = (value) => {
  if (isBlank(value)) {
    return null
  }

  return typeof value === "number" ? value : moment(value, DATE_TIME_FORMAT).unix()
}

const hoursToSeconds = (value) => {
  if (isBlank(value)) {
    return null
  }

  return Number(value) * SECONDS_PER_HOUR
}

const secondsToHours = (value) => {
  if (isBlank(value)) {
    return null
  }

  return Number(value) / SECONDS_PER_HOUR
}

const toNumber = (value) => (isBlank(value) ? null : Number(value))

const toApiFrequency = (frequency) => {
  if (!frequency) {
    return frequency
  }

  const { fixedSchedule, always } = frequency

  return {
    ...frequency,
    ...(fixedSchedule && {
      fixedSchedule: {
        ...fixedSchedule,
        dayOfMonth: toNumber(fixedSchedule.dayOfMonth),
        month: toNumber(fixedSchedule.month),
      },
    }),
    ...(always && {
      always: {
        ...always,
        intervalRate: toNumber(always.intervalRate),
        maxImpressions: toNumber(always.maxImpressions),
      },
    }),
  }
}

export const toApiPost = (form) => ({
  ...form,
  startSending: toUnix(form.startSending) ?? moment().unix(),
  stopSending: toUnix(form.stopSending),
  frequency: toApiFrequency(form.frequency),
  rules: {
    ...form.rules,
    plans: {
      ...form.rules.plans,
      maxTimeToTrialEnd: hoursToSeconds(form.rules.plans.maxTimeToTrialEnd),
    },
    minAccountAge: hoursToSeconds(form.rules.minAccountAge),
    maxAccountAge: hoursToSeconds(form.rules.maxAccountAge),
  },
})

export const defaultFormPost = () => ({
  startSending: null,
  stopSending: null,
  publishDate: null,
  title: "",
  contentHtml: "",
  format: "large",
  imageTargetUrl: null,
  rules: {
    browserLanguage: {
      isNegated: false,
      values: [],
    },
    plans: {
      isNegated: false,
      values: [POST_PLAN.FREE],
      maxTimeToTrialEnd: null,
    },
    geoPricingAvailable: null,
    newCustomer: null,
    minAccountAge: null,
    maxAccountAge: null,
    targetPages: [],
  },
  frequency: {
    once: {
      sendTimeType: "anytime",
    },
  },
})

export const toFormPost = (post) => {
  const source = JSON.parse(JSON.stringify(post ?? {}))
  const defaults = defaultFormPost()
  const rules = { ...defaults.rules, ...source.rules }

  return {
    ...defaults,
    ...source,
    frequency: source.frequency || defaults.frequency,
    rules: {
      ...rules,
      browserLanguage: { ...defaults.rules.browserLanguage, ...rules.browserLanguage },
      plans: {
        ...defaults.rules.plans,
        ...rules.plans,
        maxTimeToTrialEnd: secondsToHours(rules.plans?.maxTimeToTrialEnd),
      },
      minAccountAge: secondsToHours(rules.minAccountAge),
      maxAccountAge: secondsToHours(rules.maxAccountAge),
    },
  }
}
